import React from 'react'
import styled from 'styled-components'

import SongInfoHeader from './song-info-header'
import { Delete, Edit, Export, Copy, Permissions } from './icon-link-button'

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const TitleGroup = ({ title, subtitle, onEdit, onDelete, onExport, onCopy, onPermissions, children }) => (
  <SongInfoHeader>
    <HeaderContainer>
      <Container>
        <h1>{title}</h1>
        {onEdit && <Edit onClick={onEdit} title='Edit' />}
        {onPermissions && <Permissions onClick={onPermissions} title='Manage Permissions' />}
        {onCopy && <Copy onClick={onCopy} title='Copy' />}
        {onExport && <Export onClick={onExport} title='Export' />}
      </Container>
      {children}
      <div>
        {onDelete && <Delete onClick={onDelete} title='Delete' />}
      </div>
    </HeaderContainer>
    {subtitle && <h2>{subtitle}</h2>}
  </SongInfoHeader>
)

export default TitleGroup
